import React, { useState } from "react";
import '../css/Navigation.css';
import { getOSSImage } from "./Utils";

const logoImage = getOSSImage('logo_foot.png');
const languageToggle = getOSSImage('b_zhongwenyingwen.png');
const underline = getOSSImage('top_now.png');

export default function Navigation() {
    const [idx, SetIdx] = useState(0);

    return (
        <div className="top-nav">
            <img className="logo" alt="logo" src={logoImage} />

            <ul className="nav-bar-list">
                <li className="nav-bar-list-item">
                    <a href="/" onClick={() => SetIdx(0)}>首页</a>
                    <img className="nav-bar-now" alt="underline" src={underline} style={{ display: idx === 0 ? 'block' : "none" }} />
                </li>
                <li className="nav-bar-list-item">
                    <a href="#appinfo" onClick={() => SetIdx(1)}>应用简介</a>
                    <img className="nav-bar-now" alt="underline" src={underline} style={{ display: idx === 1 ? 'block' : "none" }} />
                </li>
                <li className="nav-bar-list-item">
                    <a href="#showcase" onClick={() => SetIdx(2)}>精彩案例</a>
                    <img className="nav-bar-now" alt="underline" src={underline} style={{ display: idx === 2 ? 'block' : "none" }} />
                </li>
                <li className="nav-bar-list-item">
                    <a href="#production" onClick={() => SetIdx(3)}>产品优势</a>
                    <img className="nav-bar-now" alt="underline" src={underline} style={{ display: idx === 3 ? 'block' : "none" }} />
                </li>
                <li className="nav-bar-list-item">
                    <a href="#experiences" onClick={() => SetIdx(4)}>用户体验</a>
                    <img className="nav-bar-now" alt="underline" src={underline} style={{ display: idx === 4 ? 'block' : "none" }} />
                </li>
                <li className="nav-bar-list-item">
                    <a href="#services" onClick={() => SetIdx(5)}>服务体系</a>
                    <img className="nav-bar-now" alt="underline" src={underline} style={{ display: idx === 5 ? 'block' : "none" }} />
                </li>
            </ul>

            <img className="language-toggle" alt="language" src={languageToggle} />
        </div>
    )
}